<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'scgl_zjhrk_cprk' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到成品入库</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="订单号"><el-input v-model="ddlist.scbh" :disabled="true"></el-input></el-form-item>
					<el-form-item label="仓库仓位">
						<el-select v-model="ddlist.ckcw" placeholder="请选择">
							<el-option :label="item.name" v-for="(item, index) in cklist" :key="index" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="单据类型"><el-input placeholder="成品入库" :disabled="true"></el-input></el-form-item>
					<el-form-item label="业务员">
						<el-select v-model="ddlist.ywy" filterable style="width: 90%;">
							<el-option v-for="item in ywylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="部门">
						<el-select v-model="ddlist.bm" filterable style="width: 90%;">
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 100px;">
				<div class="m-3 d-flex">
					<div style="width: 80%;">生产信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="scddcp" border style="width: 100%" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="cpid" label="成品编号" width="70" align="center"></el-table-column>
						<el-table-column prop="cpmc" label="成品名称/规格" width="320"></el-table-column>
						<el-table-column prop="cpbm" label="成品编码/sku" width="220"></el-table-column>
						<el-table-column prop="dw" label="单位" align="center"></el-table-column>
						<el-table-column prop="sl" label="总共数量" align="center"></el-table-column>
						<el-table-column label="本次入库" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.rksl" size="mini" :min='1' :max='scope.row.sl'></el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
		
		
	</div>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/common/mixins/common.js';
export default {
	inject: ['app', 'layout'],
	mixins: [common],
	data() {
		return {
			ywylist: [],
			ddlist: [],
			cklist:[],
			bmlist: [],
			scddcp:[],
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},

	// 生命周期
	created() {
		let lx = this.$route.query.ddlx;
		if (this.$route.query.data == 0) {
			this.ddlist = {
				scbh:'自动生成',
				ddlx: lx,
				desc: '',
				ywy: '',
				jhkssj: '',
				jhwcsj: '',
				scddcp: [],
				sclx: '',
				scz: '',
				xxdd: '',
				sfwb: 0,
				wbgys: '',
				id:'',
				cpsl:0,
				cjr: this.user.id
			};
		}else{
			this.ddlist = this.$route.query.data;
			this.scddcp = this.ddlist.scddcp
			console.log(this.ddlist)
		}

		this.axios.get('/admin/managers/list', { token: true }).then(res => {
			this.ywylist = res.data.data;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
		this.axios.get('/admin/bumens/list', { token: true }).then(res => {
			this.bmlist = res.data.data;
		});

	},
	methods: {
		//提交
		submit() {
			if(this.ddlist.ckcw == null){
				this.$message({
					type: "warning",
					message: "请选择仓库仓位"
				})
			}else{
				this.ddlist.scwc = 1
				let x = {
					data:this.ddlist,
					cpxx:this.scddcp
				}
				this.layout.showLoading()
				let url = '/admin/scdd/' + this.ddlist.id
				this.axios.post(url, x, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "下单成功"
					})
					this.$router.push({
						name: "scgl_zjhrk_cprk"
					})
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}
		},

		gettime(data) {
		    let value = data.getFullYear() + '-' +
		      this.checkTime(data.getMonth() + 1) + '-' +
		      this.checkTime(data.getDate())
		    return value
		  },

		  checkTime(i) {
		    if (i < 10) {
		      i = "0" + i
		    }
		    return i;
		  }

	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
